import { v4 } from 'uuid';

export function prizmGenerateId(): string {
  return v4();
}
